import { GlassCard } from "@kj/design-system";

export default function UsersPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Users</h1>
      <GlassCard padding="lg" radius="2xl">
        <div className="flex gap-2 mb-4">
          <input
            placeholder="Search email or id…"
            className="flex-1 rounded-xl bg-white/5 border border-white/10 px-3 py-2 text-sm"
          />
          <select className="rounded-xl bg-white/5 border border-white/10 px-3 py-2 text-sm">
            <option value="">All regions</option>
            <option value="KR">🇰🇷 KR</option>
            <option value="JP">🇯🇵 JP</option>
          </select>
        </div>
        <div className="text-sm text-fg-muted text-center py-12">
          No users yet. Connect backend via <code>/v1/admin/users</code> in Sprint 3.
        </div>
      </GlassCard>
    </div>
  );
}
